import template from "./placeholder-modal.html";
import { generatePlaceholdersVars } from "../../../../common/placeholders";

const PlaceholderModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class PlaceholderModalController {
    /* @ngInject */
    constructor($rootScope, $filter) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
    }

    $onInit() {
      this.quoteLanguage = this.resolve.quoteLanguage;
    }

    getPlaceholderValue(name) {
      const placeholders = generatePlaceholdersVars(
        this.$rootScope.quoteEditing,
        this.$rootScope.quoteEditing.lastVersion,
        true,
      );

      return placeholders[name] ? placeholders[name] : this.$filter("trans")("placeholderModal.noValue");
    }

    onSuccess(e) {
      const placeholderValue = this.getPlaceholderValue(e.text);
      e.clearSelection();
      this.close({
        $value: {
          name: e.text,
          value: placeholderValue,
        },
      });
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default PlaceholderModalComponent;
